<template>
    <div class="div">
        <datetime
                :input-class=" isFilled ? 'bold button is-small date-select ' : 'button is-small date-select'"
                v-model="carData.query.purchase_date"
                :format="{ month: 'numeric', day: 'numeric'}"
                type="date"
                value-zone="local"
                zone="local"
                @close="selectDate"
                :input-id="carData.id.toString()"
                placeholder="---"
        ></datetime>
    </div>
</template>

<script>
    import apiCars from './../../../api/apiCars'
    import { Datetime } from 'vue-datetime'
    import 'vue-datetime/dist/vue-datetime.css'
    export default {
        props:['car'],
        components: {
            Datetime
        },
        data () {
            return {
                isActive: false,
                carData:{
                    id: this.car.id,
                    query: {
                        purchase_date: this.car.purchase_date,
                    }
                }
            }
        },
        methods: {
            selectDate() {
                apiCars
                    .updateCarRequest(this.carData)
                    .then((response) => {

                    })
                    .catch(error => console.log(error))
            },

        },
        computed: {
            isFilled() {
                if (this.carData.query.purchase_date){
                    return  true;
                }
            }
        },
        mounted() {

        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Cars/Columns/BuyColumn.vue